import { render, staticRenderFns } from "./manage-presets-modal.component.vue?vue&type=template&id=49333750&scoped=true&"
import script from "./manage-presets-modal.component.vue?vue&type=script&lang=js&"
export * from "./manage-presets-modal.component.vue?vue&type=script&lang=js&"
import style0 from "./manage-presets-modal.component.vue?vue&type=style&index=0&id=49333750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49333750",
  null
  
)

export default component.exports